import React, { useEffect } from "react";
import MetaTags from "react-meta-tags";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { Link } from "react-router-dom";

// import images
import logoImg from "../../assets/images/logo-light.png";

import bg from "assets/images/background_image.jpg";

const sleep = ms => new Promise(res => setTimeout(res, ms));
const Register = props => {


  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      fname: '',
      lname: '',
      email: '',
      username: '',
    },
    validationSchema: Yup.object({
      fname: Yup.string().required("Please Enter Your First Name"),
      lname: Yup.string().required("Please Enter Your Last Name"),
      email: Yup.string().required("Please Enter Your Email"),
      username: Yup.string().required("Please Enter Your Username"),
    }),
    onSubmit: async (values) => {
      //send values
    }

  
  });

  // handleValidSubmit
  const handleValidSubmit = values => {
 
  };



  return (
    <React.Fragment>
      <MetaTags>
        <title>Register | HWA</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className=" bg-soft">
                  <Row>
      
                    <Col xs={12}>
                      <div className="text-primary p-4">
                      <img src={logoImg} alt="" className="img-fluid" height="60" />
                    
                      </div>
                    </Col>
                    
                  </Row>
                </div>
                <CardBody className="pt-0">
                 
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >


                      <div className="mb-3">
                        <Label className="form-label">First Name</Label>
                        <Input
                          id="fname"
                          name="fname"
                          className="form-control"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.fname || ""}
                          invalid={
                            validation.touched.fname && validation.errors.fname ? true : false
                          }
                        />
                        {validation.touched.fname && validation.errors.fname ? (
                          <FormFeedback type="invalid">{validation.errors.fname}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Last Name</Label>
                        <Input
                          id="lname"
                          name="lname"
                          className="form-control"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.lname || ""}
                          invalid={
                            validation.touched.lname && validation.errors.lname ? true : false
                          }
                        />
                        {validation.touched.lname && validation.errors.lname ? (
                          <FormFeedback type="invalid">{validation.errors.lname}</FormFeedback>
                        ) : null}
                      </div>
                      
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          id="email"
                          name="email"
                          className="form-control"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      

                      <div className="mt-4">
                        <button
                          className="btn btn-primary btn-block "
                          type="submit"
                        >
                          Register
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <p className="mb-0">
                          By registering you agree to Our{" "}
                          <Link to="#" className="text-primary">
                            Terms of Use
                          </Link>
                        </p>
                      </div>
                    </Form>
                  </div>
                  <div className="mt-5 text-center">
                <p>
                  Already have an account ?{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {" "}
                    Login
                  </Link>{" "}
                </p>
              </div>
                </CardBody>
              </Card>
             
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Register;
